import React, { useState } from "react";
// import IndexAddFileInputTag from "./IndexAddFileInputTag";
import { IoMdAddCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";

function IndexInsertionForm({ formFields, setFormFields }) {
  // const [preview, setPreview] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();
    const indeX = Number(e.target[0].value) - 1;
    const routeName = e.target["routeName"].value;
    const routeNameBn = e.target["routeNameBn"].value;
    const routeTags = e.target["tags"].value;
    const counterNumber = e.target["counterNumber"].value;
    const counterNumberBn = e.target["counterNumberBn"].value;

    if (indeX > -1) {
      const reArray = [...formFields];
      if (reArray?.length > 0) {
        reArray.splice(indeX, 0, {
          counterNumber: counterNumber,
          counterNumberBn: counterNumberBn,
          nameEn: routeName,
          nameBn: routeNameBn,
          tags: routeTags,
        });
        setFormFields(reArray);
        e.target.reset();
        // setPreview("");
      } else {
        toast.warn("Routes list is empty", {
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  };

  return (
    <div className="w-full mt-12">
      <div className="mt-6">
        <h2
          className={`col-span-4 font-semibold text-2xl text-gray-600 dark:text-darkWhite text-center border-b border-dashed dark:border-darkBorder pb-4 w-full mt-12 mb-16 lxs:mb-12`}
        >
          Insert to position
        </h2>
        <form onSubmit={submitHandler} className="flex flex-col gap-4">
          {/* Index */}
          <input
            type="number"
            min={1}
            placeholder="Enter position*"
            className="w-44 sm:w-44 md:w-44 sLg:w-48 lg:w-60 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
            required
          />
          {/* title */}
          <input
            type="text"
            name="routeName"
            placeholder="Enter route name"
            className="w-full darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
            required
          />
          <input
            type="text"
            name="routeNameBn"
            placeholder="Enter route name - bangla"
            className="w-full darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
            required
          />
          <input
            type="text"
            name="tags"
            placeholder="Enter tags (separate by comma)"
            className="w-full darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
            required
          />
          <input
            type="text"
            name="counterNumber"
            placeholder="Enter contact number"
            className="w-full darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
          />
          <input
            type="text"
            name="counterNumberBn"
            placeholder="Enter contact number - bangla"
            className="w-full darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
          />
          <button
            type="submit"
            className="px-7 py-2.5 w-fit border dark:border-darkBorder dark:hover:bg-darkPrimary rounded-md cursor-pointer bg-secondary/70 hover:bg-secondary text-primary border-secondary/10 hover:border-secondary transition duration-150 flex items-center gap-1"
          >
            <span>Add</span>
            <IoMdAddCircleOutline />
          </button>
        </form>
      </div>
    </div>
  );
}

export default IndexInsertionForm;
